
import { Options, Vue } from "vue-class-component";
import {
  assetsModule,
  languagesModule,
} from "@/store";
import {
  AssetsInterface,
} from "@/types";
import { PropType } from "vue";

@Options({
  name: "PinnedAssetModal",
  props: {
    pinnedAssetData: {
      type: Object as PropType<AssetsInterface>
    },
  },
})
export default class PinnedAssetModal extends Vue {
  protected unpin(assetId: string): void {
    const lang = languagesModule.getActiveLanguageCode;

    if (!assetId || !lang) return;

    assetsModule.UnpinAsset({ lang, assetId});
    this.$emit("on-close");
  }
}
